import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split('session_id=')[1]?.split('&')[0];

    if (!sessionId) {
      navigate('/login');
      return;
    }

    const processSession = async () => {
      try {
        const intended = sessionStorage.getItem("gb_intended_account_type") || null;
        sessionStorage.removeItem("gb_intended_account_type");
        const res = await axios.post(
          `${API}/auth/google-session`,
          { session_id: sessionId, intended_account_type: intended },
          { withCredentials: true }
        );
        setUser(res.data.user);
        // Sellers/dealers who signed up via Google need to complete licence info
        if (res.data.user?.needs_profile_completion) {
          navigate('/complete-profile', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login');
      }
    };
    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-4 border-slate-900 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-slate-600 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
